import { createContext } from "react";
export const SidebarCollapseContext = createContext({
    isCollapsed: false,
});
//# sourceMappingURL=collapseContext.js.map